import { MapContainer, Popup, Marker, TileLayer, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { calculateMidPoint } from "../coordinatesCalculator";
import { Box, List, ListItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Leaflet, { latLngBounds } from "leaflet";
import markerIcon from "../../../assets/location-marker.svg";
import { MainContext } from "../../../main/context/MainContextProvider";
import { PortfolioUsina } from "../types";
var greenIcon = Leaflet.icon({
  iconUrl: markerIcon,
  iconSize: [38, 38], // size of the icon
});
export type PortfolioMapProps = {
  width?: string | number;
  height?: string | number;
  usinas: PortfolioUsina[];
};

function FitBounds({ plantPositions }: { plantPositions: [number, number][] }) {
  const map = useMap();
  const bounds = latLngBounds(plantPositions);
  if (plantPositions.length === 0) {
    return undefined;
  }
  map.fitBounds(bounds);
  return null;
}

const StyledPop = styled(Popup)`
  .request-popup .leaflet-popup-content-wrapper {
    border-radius: 0px;
  }
  .leaflet-popup-content-wrapper {
    border-radius: 5;
    background-color: rgba(255, 255, 255, 0.5);
    padding: 0px;
    width: 35vh;
    height: 13vh;
    color: #00000;
  }

  .leaflet-popup-tip-container {
    visibility: hidden;
  }
`;

export default function PortfolioMap(props: PortfolioMapProps) {
  const mapRef = useRef(null);
  const { setSelectedDashboardUsina: setSelectedUsina, clientUsinas } = useContext(MainContext);
  const { theme } = useContext(MainContext);
  const { usinas } = props;
  const plantPositions: [number, number][] = usinas
    .map((plant) => {
      const location: [number, number] | undefined =
        plant.location?.latitude && plant.location?.longitude
          ? [plant.location?.latitude, plant.location?.longitude]
          : undefined;
      return location;
    })
    .filter((location) => location !== undefined) as [number, number][];
  const center = calculateMidPoint(plantPositions);
  const navigate = useNavigate();
  const [mapTileUrl, setMapTileUrl] = useState("");

  useEffect(() => {
    setMapTileUrl(
      theme.name == "dark"
        ? "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        : "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
    );
  }, [theme]);
  return (
    <Box
      sx={{
        height: props.height ?? "100%",
        width: props.width ?? "100%",
        transition: "width 0.2s",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: { xs: "10px", md: "20px" },
      }}
    >
      <MapContainer
        style={{
          height: "100%",
          width: "100%",
          margin: "10px",
        }}
        ref={mapRef}
        maxZoom={18}
        center={center}
        zoom={12}
      //       doubleClickZoom: false,
      // closePopupOnClick: false,
      // dragging: false,
      // zoomSnap: false,
      // zoomDelta: false,
      // trackResize: false,
      // touchZoom: false,
      // scrollWheelZoom: false
      // dragging={false}
      // doubleClickZoom={false}
      // zoomControl={false}
      // scrollWheelZoom={false}
      // touchZoom={false}
      >
        <TileLayer
          url={mapTileUrl}
          // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          subdomains={["a", "b", "c"]}
          maxZoom={19}
          minZoom={2}
        />
        {plantPositions.length > 0 && (
          <FitBounds plantPositions={plantPositions} />
        )}
        {usinas.map((usina) => {
          const location: [number, number] | undefined =
            usina.location?.latitude && usina.location?.longitude
              ? [usina.location?.latitude, usina.location?.longitude]
              : undefined;
          return (
            <React.Fragment key={usina.id}>
              {location && (
                <Marker
                  eventHandlers={{
                    mouseover: (event) => event.target.openPopup(),
                    mouseout: (event) => event.target.closePopup(),
                    click: (_) => {
                      navigate(`/dashboard`);
                      const selectedUsina = clientUsinas?.find(
                        (u) => u.usinaIds.id == usina.id
                      );
                      setSelectedUsina(selectedUsina);
                    },
                  }}
                  position={location}
                  icon={greenIcon}
                >
                  <StyledPop closeButton={false}>
                    <List
                      sx={{
                        fontWeight: 700,
                        fontSize: "0.8rem",
                        fontFamily: "Oswald, Montserrat",
                        marginTop: "-15px",
                      }}
                    >
                      <ListItem
                        key={usina.id}
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        {usina.name}
                      </ListItem>
                      <ListItem>
                        Potência Ativa:{" "}
                        {Number(usina.potenciaAtiva?.toFixed(2))}
                      </ListItem>
                    </List>
                  </StyledPop>
                </Marker>
              )}
            </React.Fragment>
          );
        })}
      </MapContainer>
    </Box>
  );
}
